import {collections} from './collections';

class OrdersService {
    create = data => collections().subscriptions().add(data);
}

export default new OrdersService();
